// assets
import {
  IconDashboard,
  IconUser,
  IconApps,
  IconUsers,
  IconShoppingCart,
  IconClipboard,
  IconBuildingWarehouse,
  IconBrandCampaignmonitor,
  IconClipboardCheck,
  IconClick,
  IconHierarchy2
} from '@tabler/icons';

// constant
const icons = {
  IconDashboard,
  IconUser,
  IconApps,
  IconUsers,
  IconShoppingCart,
  IconClipboard,
  IconBuildingWarehouse,
  IconBrandCampaignmonitor,
  IconClipboardCheck,
  IconClick,
  IconHierarchy2
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const externalMenu = {
  id: 'menu',
  title: 'External',
  type: 'group',
  children: [
    {
      id: 'sellers',
      title: 'Manage Sellers',
      type: 'item',
      url: '/sellers',
      icon: icons.IconApps,
      breadcrumbs: false,
      role: [1]
    },
    {
      id: 'seller-order',
      title: 'Seller Order',
      type: 'item',
      url: '/seller-order',
      icon: icons.IconShoppingCart,
      breadcrumbs: false,
      role: [0]
    },
    {
      id: 'admin-users',
      title: 'Admin Users',
      type: 'item',
      url: '/admin-users',
      icon: icons.IconUsers,
      breadcrumbs: false,
      role: [1]
    }
  ]
};

export default externalMenu;
